import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// Routes
const ListCompaniesPage = loadable(() => import('./ListCompaniesPage'), {
  fallback: <Loader />
});
const AddCompaniesPage = loadable(() => import('./AddCompaniesPage'), {
  fallback: <Loader />
});
const EditCompaniesPage = loadable(() => import('./EditCompaniesPage'), {
  fallback: <Loader />
});
const CompaniesRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListCompaniesPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddCompaniesPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditCompaniesPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
CompaniesRoute.propTypes = {
  t: PropTypes.func
};
export default CompaniesRoute;
